import Linkify from 'react-linkify';
import { Message } from '@mews-commander/messages/src';
import { NewTabLink } from '@mews-commander/ui';
import { isEnterpriseProfileData } from '@mews-commander/types';
import { useProfileData } from '../useProfileData';
import MessageResend from './MessageResend';
import { MessageBody, MessageElement, MessageHeading, UserImageContainer } from './style';
import ProfileAvatar from './ProfileAvatar';
import ProfileName from './ProfileName';

const LinkComponent = (decoratedHref: $TSFixMe, decoratedText: $TSFixMe, key: $TSFixMe) => (
    <NewTabLink url={decoratedHref} key={key}>
        {decoratedText}
    </NewTabLink>
);

interface MessageItemProps {
    message: Message;
    onResend: (message: Message) => void;
    profileId: string;
    threadId: string;
}

const MessageItem = ({ onResend, message, threadId, profileId }: MessageItemProps) => {
    const profileData = useProfileData(profileId);

    if (!profileData) {
        return null;
    }

    // @ts-expect-error
    const { text, created, creatorProfileId, isFailed } = message;

    const fromEmployee = isEnterpriseProfileData(profileData);

    return (
        <MessageElement fromEmployee={fromEmployee}>
            <UserImageContainer fromEmployee={fromEmployee}>
                <ProfileAvatar profileId={creatorProfileId} threadId={threadId} size="small" />
            </UserImageContainer>
            <MessageBody fromEmployee={fromEmployee} data-test-message-body={message.id}>
                <MessageHeading>
                    <ProfileName profileId={creatorProfileId} threadId={threadId} />
                    <br />
                    <small>{created}</small>
                </MessageHeading>
                <Linkify componentDecorator={LinkComponent}>{text}</Linkify>
                {isFailed && <MessageResend onResend={() => onResend(message)} />}
            </MessageBody>
        </MessageElement>
    );
};

export default MessageItem;
